
import { useContext} from 'react';
import ProfileTopNavigation from './ProfileTopNavigation';
import { ProfileSliderContext } from '../../appContext';
import AppointmentHistorySection from '../../PageComponent/ProfilePage/AppointmentHistorySection';
function AppointmentHistory() {
  const [slider, setSlider, handelViewRequestBlock] = useContext(
    ProfileSliderContext
  );
  return (
   
    <>
     <ProfileTopNavigation pageTitle={'Appointment History'} />
     <AppointmentHistorySection
     handleviewreqdesktop={(data, profileData)=>{handelViewRequestBlock(data, profileData)}}
     />
    </>
  );
}

export default AppointmentHistory;
